
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AccountBalanceChart } from './components/AccountBalanceChart';
import { AccountDetails } from './components/AccountDetails';

const ChartOfAccounts = () => {
  return (
    <div className="space-y-6 mt-8">
      <div>
        <h2 className="text-2xl font-bold">Chart of Accounts</h2>
        <p className="text-muted-foreground">Summary of account balances by category</p>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader className="pb-2">
            <CardTitle>Account Balances</CardTitle>
            <CardDescription>Summary of major account categories</CardDescription>
          </CardHeader>
          <CardContent>
            <AccountBalanceChart />
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader className="pb-2">
            <CardTitle>Account Details</CardTitle>
            <CardDescription>Detailed listing of all accounts</CardDescription>
          </CardHeader>
          <CardContent>
            <AccountDetails />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ChartOfAccounts;
